/** @jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
const styles = css({
  display: 'flex',
  alignItems: 'center'
});
export const UnresolvedText = ({
  icon,
  text
}) => {
  return jsx("span", {
    css: styles
  }, icon, text);
};